import { loadPrebid } from "../clients/prebid";
export const load = loadPrebid;
